import { apiFetch } from '$lib/api/helpers';
import type { LoadRequest, LoadResponse } from '$lib/types/load';

const PATH = '/loads/';

export async function fetchLoads() {
	return apiFetch<Array<LoadResponse>>(PATH);
}

export async function fetchLoadById(id: number) {
	return apiFetch<LoadResponse>(`${PATH}${id}/`);
}

export async function createLoad(loadRequest: LoadRequest) {
	return apiFetch<LoadResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(loadRequest)
	});
}

export async function createLoads(loadRequest: LoadRequest & { count: number }) {
	return apiFetch<LoadResponse[]>(`${PATH}bulk_create/`, {
		method: 'POST',
		body: JSON.stringify(loadRequest)
	});
}

export async function deleteLoad(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateLoad(id: number, loadRequest: Partial<LoadRequest>) {
	return apiFetch<LoadResponse>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(loadRequest)
	});
}

export const patchLoad = updateLoad;
